import {ButtonProps} from '@material-ui/core/Button';
import React from 'react';
import {Button} from '@material-ui/core';
import classNames from 'classnames';
import {useErrorThemeButtonStyles} from 'module/Error/hook/useErrorThemeButtonStyles';

export function ErrorButton(props: ButtonProps) {
	const classes = useErrorThemeButtonStyles()
	return <Button {...props} className={classNames(props.className,classes.root)} />
}